import { VacancyInterlinksItemModel } from '.'
import { isString, isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, registerModel } from '~/shared/model'

export default class VacancyListing extends BaseModel {
  static override constructorName = 'VacancyListing'

  key: string = ''
  label: string = ''
  items: Array<VacancyInterlinksItemModel> = []

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      if (Array.isArray(data.items)) {
        this.items = data.items.map(i => new VacancyInterlinksItemModel(i))
      }

      if (data.key && isString(data.key)) {
        this.key = data.key
      }

      if (data.label && isString(data.label)) {
        this.label = data.label
      }
    }
  }
}

registerModel(VacancyListing)
